var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.941,
    height: 9.912,
    viewBox: "0 0 15.941 9.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-number-field",
    d: "M6558.868-9071.732a.86.86,0,0,1-.869-.925v-8.071a.852.852,0,0,1,.869-.916h14.2a.852.852,0,0,1,.868.916v8.071a.859.859,0,0,1-.868.925Zm13.627-1.1a.32.32,0,0,0,.319-.318v-3.009h-6.325v3.327Zm-13.391-7.334v7.016a.32.32,0,0,0,.319.318h6.026v-7.65h-6.026A.318.318,0,0,0,6559.1-9080.163Zm13.709,3.009v-3.009a.317.317,0,0,0-.319-.316h-6.006v3.325Zm-4.52,2.317.451-.448,1.048,1.048,1.051-1.048.451.448-1.5,1.5Zm1.5-4.236-1.051,1.051-.451-.452,1.5-1.5,1.5,1.5-.451.452Z",
    transform: "translate(-6558 9081.645)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberWidget);
export default __webpack_public_path__ + "static/media/NumberWidget.86c5c865.svg";
export { ForwardRef as ReactComponent };